export default "__VITE_ASSET__Dx$WgwOz__"